const SAVE_DEBOUNCE_MS = 600;
const SAVE_MAX_WAIT_MS = 2000;

/**
 * How long to wait before saving queued edits: a debounce after the latest
 * edit, but never more than the max wait since the oldest unsaved one, so
 * continuous editing still saves. A hidden tab saves at once.
 */
export const getSaveDelay = (pendingSince: number) => {
  if (document.visibilityState === 'hidden') return 0;
  const maxWaitLeft = pendingSince + SAVE_MAX_WAIT_MS - Date.now();
  return Math.max(0, Math.min(SAVE_DEBOUNCE_MS, maxWaitLeft));
};
